<template>
  <div class="reference-prices pa-2">
    <h3 class="section-title">{{ $t(`pricing.referencePrices.header`) }}</h3>

    <v-simple-table dense class="reference-table" aria-label="Reference prices">
      <thead>
        <tr>
          <th class="group-header" colspan="2">
            {{ $t(`pricing.referencePrices.strategicEngine`) }}
          </th>
          <th class="group-header separator-left" colspan="2">
            {{ $t(`pricing.referencePrices.crossElasticityEngine`) }}
          </th>
        </tr>
        <tr>
          <th class="sub-header">{{ $t(`pricing.referencePrices.price`) }}</th>
          <th class="sub-header">{{ $t(`pricing.referencePrices.volume`) }}</th>
          <th class="sub-header separator-left">{{ $t(`pricing.referencePrices.price`) }}</th>
          <th class="sub-header">{{ $t(`pricing.referencePrices.volume`) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ data.strategic.price }}</td>
          <td>{{ data.strategic.volume }}</td>
          <td class="separator-left">{{ data.crossElasticity.price }}</td>
          <td>{{ data.crossElasticity.volume }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'ReferencePrices',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.reference-prices {
  padding-top: 0.5rem;
}

.section-title {
  margin: 0 0 0.5rem 0;
  border-bottom: 0.1rem solid $pricing-grey;
  padding-bottom: 1rem;
}

.reference-table {
  width: 100%;
  border-top: 0;

  thead th,
  tbody td {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    color: $text-color-dark;
    white-space: nowrap;
    text-align: right;
  }

  thead th.group-header {
    font-weight: 700;
    color: $text-color-dark !important;
  }

  thead th.sub-header {
    font-weight: 400;
    color: $text-color !important;
    background-color: $pricing-white;
    border-bottom: 0.1rem solid $pricing-grey !important;
  }

  .separator-left {
    border-left: 0.1rem solid $pricing-grey;
  }
}
</style>
